<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="title"
        :width="'40%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
        @ShownModal="ShownModal"
    >
        <div>
            <b-row>
                <b-col md="12">
                    <MdPassword
                        v-bind:Label="$t('Shared.NewPassword')"
                        v-bind:TypeProp="'password'"
                        v-bind:Name="'newPassword'"
                        v-bind:MaxLengthProp="45"
                        ref="inputnewpassword"
                        v-bind:TabIndex="'2'"
                        v-bind:isRequired="true"
                        v-bind:isValid="isNewPasswordValid"
                        v-bind:isEndControl="false"
                        v-model="newPassword"
                        v-bind:Autocomplete="false"
                    >
                    </MdPassword>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <MdPassword
                        v-bind:Label="$t('Shared.ConfirmPass')"
                        v-bind:TypeProp="'password'"
                        v-bind:Name="'confirmPassword'"
                        v-bind:MaxLengthProp="45"
                        ref="inputconfirmpassword"
                        v-bind:TabIndex="'3'"
                        v-bind:isRequired="true"
                        v-bind:isValid="isConfirmPasswordValid"
                        v-bind:isEndControl="true"
                        v-model="confirmPassword"
                        :EndControlFunction="EndFunction"
                        v-bind:Autocomplete="false"
                    >
                    </MdPassword>
                </b-col>
            </b-row>
        </div>
    </BaseModal>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import PatientPortalsService from '@/services/patientportals.service';

export default {
    name: 'PatientPortalChangePassword',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        userName: {
            type: String,
            required: false
        },
        contactCode: {
            type: String,
            required: false
        },
        contactName: {
            type: String,
            required: false
        },
        toContact: {
            Type: Boolean,
            default: false
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        }
    },
    data() {
        return {
            modalId: 'PatientPortalChangePasswordModal',
            emitCloseEvent: false,
            newPassword: '',
            isNewPasswordValid: true,
            confirmPassword: '',
            isConfirmPasswordValid: true
        };
    },
    computed: {
        title() {
            return `${this.$t('Shared.ChangePassword')} - ${this.$t('Shared.UserName')} ${
                this.toContact ? this.contactName : this.userName
            }`;
        }
    },
    methods: {
        resetData() {
            this.newPassword = '';
            this.isNewPasswordValid = true;
            this.confirmPassword = '';
            this.isConfirmPasswordValid = true;
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();

            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate_required()) {
                this.changePassword();
            } else {
                bvModalEvent.preventDefault();

                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        },

        ShownModal() {
            this.$nextTick(() => {
                this.$refs.inputnewpassword.setFocus();
            });
        },

        validate_required() {
            this.isNewPasswordValid = this.newPassword.length > 0 ? true : false;
            this.isConfirmPasswordValid = this.confirmPassword.length > 0 ? true : false;
            return this.isNewPasswordValid && this.isConfirmPasswordValid;
        },

        EndFunction() {
            this.changePassword();
        },

        changePassword() {
            if (this.comparePassword()) {
                PatientPortalsService.changePassword({
                    userName: this.userName,
                    contactCode: this.contactCode,
                    password: this.newPassword,
                    toContact: this.toContact
                })
                    .then(response => {
                        if (response.status == '200') {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('ChangePassWord.PassChangeMsg')
                            );

                            this.$nextTick(() => {
                                this.$emit('update:visible', false);
                                this.resetData();
                            });
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Shared.DontMatch'),
                    'error'
                );
            }
        },

        comparePassword() {
            if (this.newPassword === this.confirmPassword) {
                return true;
            }
            return false;
        }
    }
};
</script>
